"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitButton = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./SplitButton.css"));
var SplitButton = function (_a) {
    var type = _a.type, optionMenuItems = _a.optionMenuItems, onPrimaryClick = _a.onPrimaryClick, primaryButtonLabel = _a.primaryButtonLabel, disabled = _a.disabled, autoStack = _a.autoStack;
    var OptionMenuButton = (react_1.default.createElement(kaleidoscope_1.IconButton, { type: type, icon: react_1.default.createElement(icons_1.ChevronDown, null), size: kaleidoscope_1.ButtonSize.Small, disabled: disabled, className: styles.button({ type: type }), "aria-label": "Options", "aria-disabled": disabled }));
    return (react_1.default.createElement("div", { className: styles.wrapper },
        react_1.default.createElement(kaleidoscope_1.Button, { type: type, size: kaleidoscope_1.ButtonSize.Small, className: styles.button({ type: type }), onClick: onPrimaryClick, disabled: disabled, buttonState: kaleidoscope_1.ButtonState.Idle }, primaryButtonLabel),
        react_1.default.createElement(kaleidoscope_1.OptionMenu, { button: OptionMenuButton, size: "small", autoStack: autoStack }, optionMenuItems)));
};
exports.SplitButton = SplitButton;
SplitButton.defaultProps = {
    type: kaleidoscope_1.ButtonType.Primary,
};
